import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeResourceUrl, SafeScript, SafeStyle, SafeUrl } from '@angular/platform-browser';

export type SafeValueContext = 'html' | 'style' | 'script' | 'url' | 'resource';

@Pipe({
  name: 'safeValue',
  pure: true,
})
export class SafeValuePipe implements PipeTransform {
  constructor(private readonly domSanitizer: DomSanitizer) {}

  transform(value: string | undefined | null, valueType: SafeValueContext): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
    switch (valueType) {
      case 'html':
        return this.domSanitizer.bypassSecurityTrustHtml(value as string);
      case 'style':
        return this.domSanitizer.bypassSecurityTrustStyle(value as string);
      case 'script':
        return this.domSanitizer.bypassSecurityTrustScript(value as string);
      case 'url':
        return this.domSanitizer.bypassSecurityTrustUrl(value as string);
      case 'resource':
        return this.domSanitizer.bypassSecurityTrustResourceUrl(value as string);
      default:
        throw new Error(`Invalid SafeValueContext: ${valueType}`);
    }
  }
}
